import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Authentication from '@zorgconnect/shared-portal/Modules/Authentication';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './Reducers';
import { Map } from 'immutable';
import * as serviceWorker from './serviceWorkerRegistration';
import moment from 'moment-timezone';
import 'moment/locale/nl';
import { AuthenticationProvider } from './Authentication/Context/AuthenticationContext';
import { PWAProvider } from './PWA/Context/PWAContext';
import ConnectionProvider from './Context/Connection';
import MissedEntriesProvider from './Context/MissedEntries';
moment.locale('nl', { dow: 1 });

export const appVersion = "2.1.0";

let composeMiddleware = undefined;

if(window.__REDUX_DEVTOOLS_EXTENSION__) {
    composeMiddleware = compose(
        applyMiddleware(thunk),
        window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );
} else {
    composeMiddleware = applyMiddleware(thunk);
}


const store = createStore(
    rootReducer, 
    Map(),
    composeMiddleware
);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(<ConnectionProvider>
        <PWAProvider>
            {/* <AuthenticationProvider> */}
                <Authentication version={appVersion} portalLabel="light">
                    <MissedEntriesProvider>
                        <Provider store={store}>
                            <App />
                        </Provider>
                    </MissedEntriesProvider>
                </Authentication>
            {/* </AuthenticationProvider> */}
        </PWAProvider>
    </ConnectionProvider>

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
    onUpdate: (registration) => {
        // if (window.confirm('Er is een nieuwe versie beschikbaar, herstart de applicatie?')) {
        //     registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        // }
    }
});
